import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-arrow-down",
  "use": "ico-arrow-down-usage",
  "viewBox": "0 0 22.768 13.156",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.768 13.156\" id=\"ico-arrow-down\">\n  <path id=\"ico-arrow-down_Path_183\" data-name=\"Path 183\" d=\"M1390.779,46.3l10.6,10.5,10.4-10.5\" transform=\"translate(-1389.9 -45.413)\" fill=\"none\" stroke=\"#747878\" stroke-width=\"2.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol